import { Component, HostListener, OnInit } from '@angular/core';
import { BaseFormComponent } from 'src/app/shared/base/base-form.component';
import { OptionsSource } from 'src/app/core/core.models';
import { AuthService } from 'src/app/core/auth.service';
import { LoadingService } from 'src/app/core/loading.service';
import { TranslatorService } from 'src/app/core/translator.service';
import { UtilityService } from 'src/app/core/utility.service';
import { DialogService, Dialog } from 'src/app/core/dialog.service';
import { AlertService } from 'src/app/core/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from 'src/app/shared/base/base.service';
import { Constants, SearchOperations } from 'src/app/app.constants';
import { PointsOfSaleService } from '../../points-of-sale/points-of-sale.service';
import { TranslateService } from '@ngx-translate/core';
import { PointOfSale, PointOfSaleType } from '../../points-of-sale/points-of-sale.models';
import { OfferedProductsService } from '../../offered-products/offered-products.service';
import { ProductCatalogue, ProductCatalogueStatus, CopyType } from '../product-catalogues.models';
import { ProductCataloguesService } from '../product-catalogues.service';
import { ValueLabel, Image } from 'src/app/shared/base/base.models';
import { ViewChild } from '@angular/core';
import { DxButtonComponent } from 'devextreme-angular';
import { BusinessPartnersService } from '../../business-partners/business-partners.service';
import { BusinessPartner } from '../../business-partners/business-partners.models';
import { Location } from '@angular/common';
import * as moment from 'moment';
import { ProfileService } from '../../profile/profile.service';
import { ProductCatalogueItemsService } from '../product-catalogue-items.service';


@Component({
  selector: 'app-product-catalogues-form',
  templateUrl: './product-catalogues-form.component.html',
  styleUrls: ['./product-catalogues-form.component.scss']
})
export class ProductCataloguesFormComponent extends BaseFormComponent implements OnInit {
  @ViewChild('btnSave') btnSave: DxButtonComponent;

  tabs: string[] = ['ITEMS'];
  colCount: number = 4;

  productCatalogueStatuses: ValueLabel[] = [];

  selectedIds: string[] = [];

  ProductCatalogueStatus = ProductCatalogueStatus;
  offeredProducts: OptionsSource;
  businessPartners: OptionsSource;
  pointsOfSale: OptionsSource;
  pointOfSaleId: string;
  pointOfSaleType?: PointOfSaleType | string;

  minDateFrom: Date = new Date();
  percentageFormat = '#%';

  isProductsModalVisible: boolean = false;
  isCopyCatalogueWithItemsVisible: boolean = false;

  reportCode: string;

  isCopyModalVisible: boolean = false;
  code: string;

  showActivateButton: boolean = true;
  showDeactivateButton: boolean = false;
  showDeleteButton: boolean = false;

  today: Date = new Date();
  selectedCopyType: string;
  copyTypes: ValueLabel[] = [];

  reportData: ProductCatalogue = new ProductCatalogue();

  constructor(
    private location: Location,
    private translateService: TranslateService,
    private productCataloguesService: ProductCataloguesService,
    private offeredProductsService: OfferedProductsService,
    private businessPartnerService: BusinessPartnersService,
    private pointsOfSaleService: PointsOfSaleService,
    public authService: AuthService,
    public loadingService: LoadingService,
    public translatorService: TranslatorService,
    public utilityService: UtilityService,
    protected activatedRoute: ActivatedRoute,
    protected baseService: BaseService,
    protected dialogService: DialogService,
    protected router: Router,
    protected alertService: AlertService,
    private profileService: ProfileService,
    private productCatalogueItemsService: ProductCatalogueItemsService
  ) {
    super(authService, loadingService, translatorService, utilityService, activatedRoute, baseService, dialogService, router, alertService)
    // this.onEditorPreparing = this.onEditorPreparing.bind(this);
    // this.onSelectionChanged = this.onSelectionChanged.bind(this);
  }


  ngOnInit(): void {
    this.authorities.init('CD_CD', 'R_CD', 'U_CD', 'CD_CD');
    this.url = `${Constants.contextPath}/product-catalogues`;
    this.prepareLookupData();

    this.prepareFormData(new ProductCatalogue(), (response: ProductCatalogue) => {
      return this.modifyResponse(response);
    });
  }

  ngAfterViewInit() {
    this.btnSave.disabled = !this.pendingChanges;
  }


  public changePendingStatus() {
    this.pendingChanges = true;
    this.btnSave.disabled = !this.pendingChanges;
  }


  public onFieldDataChanged($event: any): void {
    if (!this.pendingChanges && this.initialFormData[$event.dataField] != $event.value && this.btnSave != null && !this.showDeactivateButton) {
      this.pendingChanges = true;
      this.btnSave.disabled = !this.pendingChanges;
    } else {
      this.pendingChanges = false;
    }
  }

  prepareLookupData() {
    this.productCatalogueStatuses = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(ProductCatalogueStatus, true), 'value', 'label', 'ENUMS.PRODUCT_CATALOGUE_STATUS.');
    this.businessPartners = this.businessPartnerService.getBusinessPartnerOptions();
    this.pointsOfSale = this.pointsOfSaleService.getPointsOfSaleOptions();
    this.copyTypes = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(CopyType, true), 'value', 'label', 'ENUMS.COPY_TYPES.');
    if (this.pointOfSaleId != null)
      this.offeredProducts = this.offeredProductsService.getOfferedProductsOptionsByPointOfSale(this.pointOfSaleId, `product${SearchOperations.SPLIT_JOIN_OPERATOR}active${SearchOperations.EQUALITY}${true}`);
  }

  public modifyResponse(response: ProductCatalogue) {
    this.reportData = JSON.parse(JSON.stringify(response));
    response.breadcrumbsId = response.code;

    if (response.pointOfSale) {
      let pointOfSale = <PointOfSale>response.pointOfSale;
      this.determineReportCode(pointOfSale.type);
      response.pointOfSale = pointOfSale.id;
      this.pointOfSaleId = pointOfSale.id
      this.pointOfSaleType = pointOfSale.type;
    }

    if (response.businessPartner) {
      let businessPartner = <BusinessPartner>response.businessPartner;
      response.businessPartner = businessPartner.id;
    }

    this.showDeleteButton = response.status == ProductCatalogueStatus[ProductCatalogueStatus.DRAFT];
    this.showActivateButton = response.status == ProductCatalogueStatus[ProductCatalogueStatus.DRAFT];
    this.showDeactivateButton = response.status == ProductCatalogueStatus[ProductCatalogueStatus.ACTIVE];

    return response;
  }

  public saveChanges(statusChange: boolean = false, activate: boolean = true): void {
    if (!this.isFormValid())
      return;

    this.formData.validFrom = this.utilityService.getStartOfDay(this.formData.validFrom);
    this.formData.validTo = this.utilityService.getEndOfDay(this.formData.validTo);

    let data = JSON.parse(JSON.stringify(this.formData));

    if (this.id == null)
      this.baseService.create(this.url, data, (response) => {
        this.onSaveSuccessNew(response, true);
      });
    else
      this.baseService.update(this.url, data, (response) => {
        if (statusChange)
          this.onStatusChangeSaveSuccess(activate);
        else
          this.onSaveSuccessNew(response);
      });
  }

  determineReportCode(posType) {
    if (posType == PointOfSaleType[PointOfSaleType.WHOLESALE])
      this.reportCode = 'B2BCTLG';
    else
      this.reportCode = 'CTLG';
  }

  onSaveSuccessNew(response: ProductCatalogue, isCreate: boolean = false) {
    this.initializeForm(this.modifyResponse(response));
    this.pendingChanges = false;
    this.alertService.success('SHARED.SAVE_SUCCESS');
    if (isCreate) {
      this.id = response.id;
      this.location.go(`/product-catalogues/${response.id}`);
      // this.router.navigateByUrl(this.router.url.split('/')[1] + '/' + response.id);
    }
  }

  onStatusChangeSaveSuccess(activate: boolean) {
    this.productCataloguesService.changeStatus(<string>this.id, activate, (response) => {
      this.alertService.success(activate ? 'SHARED.ACTIVATE_SUCCESS' : 'SHARED.DEACTIVATE_SUCCESS');
      this.formData = this.modifyResponse(response);
      this.pendingChanges = false;
    });
  }

  public openCopyModal(id: string) {
    this.isCopyModalVisible = true;
  }

  public closeCopyModal() {
    this.code = null;
    this.isCopyModalVisible = false;
  }

  public copyCatalogue() {
    if (this.code == null || this.code.length < 3) {
      this.alertService.error('PRODUCT_CATALOGUES.COPY_CODE_INVALID');
      return;
    }

    let selectedItems = this.selectedIds;

    this.productCataloguesService.copyProductCatalogue(<string>this.id, this.code, this.selectedCopyType, selectedItems, (response) => {
      this.closeCopyModal();
      this.alertService.success('PRODUCT_CATALOGUES.CATALOGUE_COPIED_SUCCESSFULLY');
      this.router.navigate(['product-catalogues', response.id]);
      // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      //   this.router.navigate(['product-catalogues', response.id]);
      // });
    }, (error) => {
      this.alertService.error(error, true);
    });
  }

  itemSelectionChanged(event) {
    this.selectedIds = event;
  }

  public changeStatus() {
    let activate: boolean = true;
    if (this.formData.status == ProductCatalogueStatus[ProductCatalogueStatus.ACTIVE])
      activate = false;

    let dialogData = new Dialog(activate ? 'SHARED.ACTIVATE_QUESTION' : 'SHARED.DEACTIVATE_QUESTION', () => {
      if (this.pendingChanges) {
        this.saveChanges(true, activate);
      } else {
        this.productCataloguesService.changeStatus(<string>this.id, activate, (response) => {
          this.alertService.success(activate ? 'SHARED.ACTIVATE_SUCCESS' : 'SHARED.DEACTIVATE_SUCCESS');
          this.formData = this.modifyResponse(response);
          this.pendingChanges = false;
        });
      }
    });

    this.dialogService.show(dialogData);
  }

  public assignPointOfSaleId = (event) => {
    if (event.selectedItem && this.pointOfSaleId != event.selectedItem.id) {
      this.pointOfSaleId = event.selectedItem.id;
      this.reportData.pointOfSale = event.pointOfSale;
    }
  }

  public businessPartnerChanged = (event) => {
    if (this.reportData)
      this.reportData.businessPartner = event.selectedItem;
  }


  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.colCount = event.target.innerWidth > 999 ? 4 : 1;
  }

  public checkValidDate(date: Date) {
    return moment().isBefore(date)
    // return new Date(date).toISOString() > new Date().toISOString();
  }

  public openCopyCatalogueWithItemsModal() {
    this.code = this.formData.code;
    this.isCopyCatalogueWithItemsVisible = true;
  }

  public closeCopyCatalogueWithItemsModal() {
    this.isCopyCatalogueWithItemsVisible = false;
  }

  deactivateItemsAndCopyIntoCatalogue() {
    if (this.selectedIds.length == 0) {
      this.alertService.error('PRODUCT_CATALOGUES.NO_SELECTED_ITEMS');
      return;
    } else if (this.code == this.formData.code) {
      this.alertService.error('PRODUCT_CATALOGUES.CATALOGUE_NAME_MUST_BE_DIFFERENT');
      return;
    } else {
      let itemIds: string[] = JSON.parse(JSON.stringify(this.selectedIds));
      this.productCataloguesService.copyCatalogueWithDeactivatedItems(this.id, itemIds, this.code, (productCatalogue) => {
        this.alertService.successCustomMessage(this.translateService.instant('PRODUCT_CATALOGUES.DEACTIVATE_AND_COPY_SUCCESS') + " " + this.code, null)
      }), (error) => {
        this.alertService.error(error)
      }
    }
  }

  deleteCatalogue() {
    let dialog = new Dialog('SHARED.DELETE_QUESTION', () => {
      this.baseService.delete(this.url, this.id, () => {
        this.alertService.success('SHARED.DELETE_SUCCESS');
        this.router.navigate(['product-catalogues']);
      }, (error) => {
        this.alertService.error(error, true);
      });
    });

    this.dialogService.show(dialog);
  }

  private prepareForPrint = (response, onSuccess: Function) => {
    response.logo = this.profileService.logo;

    this.productCatalogueItemsService.getListByProductCatalogueId(response.id, result => {

      response.items = result ? result : new Array();
      if (response.items) {
        for (let i of response.items) {
          if (i.offeredProduct && i.offeredProduct.product && i.offeredProduct.product.images)
            i.offeredProduct.product.image = this.utilityService.extractMainImage(i.offeredProduct.product.images)
        }
      }

      onSuccess(result);
    });
  }


}
